const DessertData = [
  {
    productname: "Lemon Tart",
    productdescription:
      "Made with pure ingredients such as almond, lemons, dates and raw cashews",
  },
  {
    productname: "Choco Mousse",
    productdescription: "Light mousse yet intensely chocolate",
  },
  {
    productname: "Banoffee Pie",
    productdescription:
      "A magical tri-layer English confection with soya cream, bananas and nuts that will make your taste buds sing!",
  },
  {
    productname: "Tiramisu",
    productdescription:
      "Timeless no-bake Italian dessert combining almonds, dates and lightly sweetened plant-based cream with hazelnut paste",
  },
];
export default DessertData;
